import React from 'react';
import toast from 'react-hot-toast';

export const confirmAction = (message, onConfirm) => {
  toast.custom((t) => (
    <div
      style={{
        background: '#fff',
        padding: '16px 24px',
        borderRadius: '12px',
        boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        maxWidth: '400px',
        border: '1px solid #e2e8f0',
        animation: t.visible ? 'fadeIn 0.2s ease-out' : 'fadeOut 0.2s ease-out'
      }}
    >
      <div style={{ fontWeight: '600', color: '#0f172a', fontSize: '15px' }}>
        {message}
      </div>
      <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
        <button
          onClick={() => toast.dismiss(t.id)}
          style={{
            padding: '8px 16px',
            borderRadius: '6px',
            border: '1px solid #cbd5e1',
            background: '#f8fafc',
            color: '#475569',
            fontWeight: '500',
            cursor: 'pointer',
            fontSize: '13px'
          }}
        >
          Cancel
        </button>
        <button
          onClick={() => {
            toast.dismiss(t.id);
            onConfirm();
          }}
          style={{
            padding: '8px 16px',
            borderRadius: '6px',
            border: 'none',
            background: '#ef4444',
            color: '#fff',
            fontWeight: '600',
            cursor: 'pointer',
            fontSize: '13px'
          }}
        >
          Yes, I'm sure
        </button>
      </div>
    </div>
  ), { duration: Infinity });
};
